import { render } from "./ProductDetailSchemaJson.vue?vue&type=template&id=49d9de15"
import script from "./ProductDetailSchemaJson.vue?vue&type=script&lang=js"
export * from "./ProductDetailSchemaJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__